// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore?tab=readme-ov-file#_pick

export function pick(object: Record<string, unknown>, keys: string[]) {
  return keys.reduce((obj: Record<string, unknown>, key: string) => {
    if (object && object.hasOwnProperty(key)) {
      // eslint-disable-next-line no-param-reassign
      obj[key] = object[key]
    }
    return obj
  }, {})
}
